import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  proxy: false,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  const authToken = localStorage.getItem("token");
  if (authToken) {
    // console.log('Request Interceptor Triggered:');
    // console.log('Request Base URL:', config.baseURL); // Should log 'http://18.132.97.120:8000/'
    // console.log('Request URL:', config.url); // Logs /user-role/menu or other endpoint
    // console.log('Request Method:', config.method); // Logs the HTTP method (GET, POST, etc.)
    // console.log('Request Headers Before Authorization:', config.headers);
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  return config;
});

export default axiosInstance;
